import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectorAirDetailsComponent } from './sector-air-details.component';
import { SectorAirDetailsTravellerModule } from './sector-air-details-traveller/sector-air-details-traveller.module';
import { SectorAirFlightDetailsModule } from 'libraries/component/sector-air-flight-details/sector-air-flight-details.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';

@NgModule({
    imports: [
        CommonModule,
        SectorAirDetailsTravellerModule,
        SectorAirFlightDetailsModule,
        NotificationModule,
    ],
    exports: [
        SectorAirDetailsComponent,
    ],
    declarations: [
        SectorAirDetailsComponent
    ],
})
export class SectorAirDetailsModule { }
